// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2s5uX","content":"RecentSearches_content__2tqST"};